<template>
    <div class="account-address">
        <transition name="account-address-fade" mode="out-in">
            <view-address
                v-if="!editAddress"
                key="view"
                v-bind="$attrs"
                :label="label"
                :address="value"
                @edit="editAddress = true"
            />
            <edit-address
                v-else
                key="edit"
                :address="value"
                v-bind="$attrs"
                :label="label"
                v-on="$listeners"
                @cancel="editAddress = false"
                @save="saveInfo"
            >
                <template v-slot:copy-from-billing>
                    <slot name="copy-from-billing" />
                </template>
            </edit-address>
        </transition>
    </div>
</template>

<script>
import ViewAddress from './view_address'
import EditAddress from './edit_address'

export default {
    name: `AccountAddressRoot`,
    components: {
        ViewAddress,
        EditAddress
    },

    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        },
        label: {
            type: String,
            default: () => `Address`
        }
    },

    data: () => ({
        editAddress: false
    }),

    methods: {
        saveInfo() {
            this.editAddress = false
        }
    }
}
</script>

<style scoped>
.account-address {
    min-width: 0;
}
.account-address-fade-enter-active,
.account-address-fade-leave-active {
    transition: opacity 150ms ease, transform 150ms ease;
}
.account-address-fade-enter,
.account-address-fade-leave-to {
    opacity: 0;
    transform: translateY(4px);
}
@media (prefers-reduced-motion: reduce) {
    .account-address-fade-enter-active,
    .account-address-fade-leave-active {
        transition: none;
    }
}
</style>
